var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20549 6.29408L4.51569 4.97929C5.45971 4.03196 5.82975 3.52234 6.34092 3.7025C6.97835 3.92714 6.76851 5.34457 6.76851 5.8231C7.75955 5.8231 8.78989 5.73502 9.76677 5.91854C12.9916 6.52439 14 9.14351 14 12C13.0873 11.3534 12.1754 10.6646 11.0784 10.365C9.70909 9.99095 8.17974 10.1694 6.76851 10.1694C6.76851 10.6479 6.97835 12.0654 6.34092 12.29C5.76167 12.4941 5.45971 11.9606 4.51569 11.0133L3.20549 9.69846C2.40183 8.89198 2 8.48874 2 7.99627C2 7.5038 2.40183 7.10056 3.20549 6.29408Z",
    stroke: "#494950",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuote);
export default __webpack_public_path__ + "static/media/icon-quote.49fa3a60c5e08ceb0889108ade1f674b.svg";
export { ForwardRef as ReactComponent };